import { NgModule } from '@angular/core';
import { ReportsRoutingModule } from './reports-routing.module';

@NgModule({
  imports: [
    ReportsRoutingModule
  ]
})
export class ReportsModule { }
